module.exports = __webpack_public_path__ + "media/images/default-organization-logo-b352f19db310b6fea2e4af18fd9ae469.png";